var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"page-name":'forgot-password',"is-loading":false}},[(!_vm.isRequestSent)?_c('ForgotPasswordForm'):_c('ResendForgotPasswordForm',{staticClass:"forgot-password__resend-forgot-password"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }